<div class="save-complete">
  <div class="save-complete__message">Merke dir diesen Code, damit du deine Merkliste wieder öffnen kannst.</div>

  <div class="save-complete__code">
    {{code}}
  </div>

  <div class="save-complete__confirm" (click)="onClosed.emit(true)">
    <brt-button [title]="'Ok'"></brt-button>
  </div>
</div>
